// extracted by mini-css-extract-plugin
module.exports = {"topNews":"topNews-2BQWVUtl","first_title":"first_title-1mv1jLMv","second_title":"second_title-1QD9gZws","children":"children-1u2o-F1z"};